export enum SequenceCreateStep {
  INFORMATION = 0,
  PATIENT = 1,
  PICTURES = 2,
}
